import Vue from 'vue';
import VueRx from 'vue-rx';
import axios from 'axios';
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import store, { SET_USER } from './store';

Vue.config.productionTip = false;

Vue.use(VueRx);
Vue.use(ModalPlugin);
Vue.use(ToastPlugin);

const isFromSameAuthSession = (to, from) => from.meta.auth && to.meta.role === from.meta.role;

const requireLogin = (to, from, next, path) => {
  if (!to.meta.auth) {
    next({
      path,
      query: {
        redirect: to.fullPath,
      },
    });
  }
};

const authGuard = async (to, from, next) => {
  if (to.path === '/tnc') {
    next();
    return;
  }
  if (!store.state.user && !isFromSameAuthSession(to, from)) {
    let authUrl;
    let loginPath;
    if (to.path.indexOf('/admin') === 0) {
      authUrl = '/agc-admin-api/auth';
      loginPath = '/admin/login';
    } else {
      authUrl = '/agc-merchant-api/auth';
      loginPath = '/login';
    }
    try {
      const {
        data: { payload },
      } = await axios.get(authUrl);
      if (payload) {
        store.commit(SET_USER, payload);
      } else {
        requireLogin(to, from, next, loginPath);
      }
    } catch (e) {
      requireLogin(to, from, next, loginPath);
    }
  }
  if (store.state.user && to.meta.auth) {
    const { role } = store.state.user;
    if (role === 'admin') {
      next({ path: '/admin' });
    }
    if (role === 'merchant') {
      next({ path: '/' });
    }
  }
  next();
};

router.beforeEach(authGuard);
router.afterEach(({ path }) => {
  window.ga('send', 'pageview', `/agc${path}`);
  // window.dataLayer.push({
  //   event: 'ultriggerpageview',
  //   ga4: {
  //     pageview_event_name: 'page_view',
  //     title: 'NA',
  //     content: {
  //       id: 'NA',
  //       type: 'NA',
  //     },
  //     video: {
  //       program: 'NA',
  //     },
  //     author: 'NA',
  //     taglist: 'NA',
  //     service: 'merchant',
  //     category: 'NA',
  //     publishdate: 'NA',
  //     primary: {
  //       main: 'NA',
  //       sub: 'NA',
  //     },
  //     pageurl: window.location.href,
  //   },
  // });
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
